// @ts-nocheck -- see CLAUDE.md's "TypeScript checking on assets/*.js" section for why
window.OXTAK_I18N = window.OXTAK_I18N || {};
var OXE_I18N = window.OXE_I18N;
Object.keys(OXE_I18N).forEach(function (code) {
  window.OXTAK_I18N[code] = window.OXTAK_I18N[code] || {};
  window.OXTAK_I18N[code].elite = OXE_I18N[code];
});
(function () {
  var steps = document.querySelectorAll("#oxe-steps .step-acc-item");
  function setActiveStep(next) {
    steps.forEach(function (el, i) {
      el.classList.toggle("step-acc-item--active", i === next);
    });
  }
  function onStepScroll() {
    var trigger = window.innerHeight * 0.45;
    var next = 0;
    steps.forEach(function (el, i) {
      if (el.getBoundingClientRect().top < trigger) next = i;
    });
    setActiveStep(next);
  }
  onStepScroll();
  steps.forEach(function (el, i) {
    el.addEventListener("click", function () {
      setActiveStep(i);
    });
  });

  var ucData = [
    {
      tab: "Meeting capture",
      img: "https://cdn.shopify.com/s/files/1/0961/3285/8162/files/uc_meeting_capture.png?v=1784809057",
      heading: "Notes, decisions, action items.",
      desc: "Your agent listens in, extracts every decision and next step, assigns action items to the right people, and files the summary before you leave the room.",
    },
    {
      tab: "Proposal drafts",
      img: "https://cdn.shopify.com/s/files/1/0961/3285/8162/files/uc_proposal_drafts.png?v=1784809057",
      heading: "Talk through the shape. Walk back to a draft.",
      desc: "Describe the outline out loud. Your agent picks up context from the conversation, structures the document, and drops the finished draft in your inbox.",
    },
    {
      tab: "Inbox triage",
      img: "https://cdn.shopify.com/s/files/1/0961/3285/8162/files/uc_inbox_triage.png?v=1784809056",
      heading: "Filtered, summarized, replies queued.",
      desc: "Your agent scans your inbox, surfaces what needs a response today, drafts replies for your approval, and archives the rest.",
    },
    {
      tab: "Ticket creation",
      img: "https://cdn.shopify.com/s/files/1/0961/3285/8162/files/uc_ticket_creation.png?v=1784809056",
      heading: "Jira tickets dictated in plain speech.",
      desc: "Describe the issue naturally. Your agent creates the ticket, applies the right labels, assigns it, and sets the priority — no app switching required.",
    },
    {
      tab: "Schedule coordination",
      img: "https://cdn.shopify.com/s/files/1/0961/3285/8162/files/uc_schedule_coordination.png?v=1784809057",
      heading: "Calendar handshake done.",
      desc: "Your agent checks your calendar, finds the best open slot, sends the invite, and confirms — without you opening a calendar app.",
    },
  ];
  var ucWrap = document.getElementById("oxe-uc");
  var ucImg = document.getElementById("oxe-uc-img");
  var ucHeading = document.getElementById("oxe-uc-heading");
  var ucDesc = document.getElementById("oxe-uc-desc");
  var ucTabs = document.querySelectorAll("#oxe-uc-tabs .uc-tab");
  var ucActive = 0;
  var ucFadeTimeout = null;
  function changeTab(i) {
    if (i === ucActive) return;
    if (ucFadeTimeout) clearTimeout(ucFadeTimeout);
    ucActive = i;
    ucTabs.forEach(function (t, idx) {
      t.classList.toggle("uc-tab--active", idx === i);
    });
    ucWrap.classList.add("uc-tabs--fading");
    ucFadeTimeout = setTimeout(function () {
      var d = ucData[i];
      var loc = window.getOxtakLocale();
      var tDict =
        (window.OXTAK_I18N[loc] || window.OXTAK_I18N.en).elite.usecases.tabs[
          i
        ] || {};
      ucImg.src = d.img;
      ucImg.alt = tDict.tab || d.tab;
      ucHeading.textContent = tDict.heading || d.heading;
      ucDesc.textContent = tDict.desc || d.desc;
      ucWrap.classList.remove("uc-tabs--fading");
    }, 450);
  }
  ucTabs.forEach(function (t) {
    t.addEventListener("click", function () {
      changeTab(parseInt(t.getAttribute("data-i"), 10));
    });
  });

  var deviceSection = document.getElementById("oxe-device-section");
  var deviceImg = document.getElementById("oxe-device-img");
  function onParallax() {
    if (!deviceSection || !deviceImg) return;
    var rect = deviceSection.getBoundingClientRect();
    var viewH = window.innerHeight;
    var raw = (viewH - rect.top) / viewH;
    var clamped = Math.max(0, Math.min(1, raw));
    deviceImg.style.transform = "translateY(" + clamped * 130 + "px)";
  }
  onParallax();

  var scrollTicking = false;
  function onScrollBatched() {
    if (scrollTicking) return;
    scrollTicking = true;
    window.requestAnimationFrame(function () {
      onStepScroll();
      onParallax();
      scrollTicking = false;
    });
  }
  window.addEventListener("scroll", onScrollBatched, { passive: true });

  var atbSelected = ["pa"];
  var atbCards = document.querySelectorAll("#oxe-atb-grid .atb-card");
  var atbPrompt = document.getElementById("oxe-atb-prompt");
  var atbCount = document.getElementById("oxe-atb-count");
  function getPrompt(n) {
    var loc = window.getOxtakLocale();
    var t = (window.OXTAK_I18N[loc] || window.OXTAK_I18N.en).elite.agents || {};
    if (n === 0) return t.prompt0 || "Choose 3 roles to build your team.";
    if (n === 3) return t.prompt3 || "Your team is ready.";
    var rem = 3 - n;
    return "Choose " + rem + " more role" + (rem === 1 ? "" : "s") + ".";
  }
  function renderAtb() {
    var full = atbSelected.length >= 3;
    atbPrompt.textContent = getPrompt(atbSelected.length);
    atbPrompt.classList.toggle("atb-prompt--ready", full);
    atbCount.textContent = atbSelected.length + " / 3";
    atbCards.forEach(function (card) {
      var id = card.getAttribute("data-id");
      var isSelected = atbSelected.indexOf(id) > -1;
      var isDimmed = full && !isSelected;
      card.classList.toggle("atb-card--selected", isSelected);
      card.classList.toggle("atb-card--dimmed", isDimmed);
      var check = card.querySelector(".atb-check");
      if (isSelected && !check) {
        var div = document.createElement("div");
        div.className = "atb-check";
        div.innerHTML =
          '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
        card.insertBefore(div, card.firstChild);
      } else if (!isSelected && check) {
        check.remove();
      }
    });
  }
  atbCards.forEach(function (card) {
    card.addEventListener("click", function () {
      var id = card.getAttribute("data-id");
      var idx = atbSelected.indexOf(id);
      if (idx > -1) {
        atbSelected.splice(idx, 1);
      } else if (atbSelected.length < 3) {
        atbSelected.push(id);
      }
      renderAtb();
    });
  });
  renderAtb();

  var track = document.getElementById("oxe-gallery-track");
  var dotsWrap = document.getElementById("oxe-gallery-dots");
  var prevBtn = document.getElementById("oxe-gallery-prev");
  var nextBtn = document.getElementById("oxe-gallery-next");
  var cards = track.querySelectorAll(".gallery-card");
  cards.forEach(function (c, i) {
    var dot = document.createElement("button");
    dot.className = "carousel-dot" + (i === 0 ? " carousel-dot--active" : "");
    dot.addEventListener("click", function () {
      c.scrollIntoView({
        behavior: "smooth",
        inline: "start",
        block: "nearest",
      });
    });
    dotsWrap.appendChild(dot);
  });
  var dots = dotsWrap.querySelectorAll(".carousel-dot");
  function updateNav() {
    var idx = 0;
    var min = Infinity;
    cards.forEach(function (c, i) {
      var d = Math.abs(c.offsetLeft - track.scrollLeft);
      if (d < min) {
        min = d;
        idx = i;
      }
    });
    dots.forEach(function (d, i) {
      d.classList.toggle("carousel-dot--active", i === idx);
    });
    prevBtn.disabled = track.scrollLeft <= 4;
    nextBtn.disabled =
      track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
  }
  track.addEventListener(
    "scroll",
    function () {
      window.requestAnimationFrame(updateNav);
    },
    { passive: true },
  );
  prevBtn.addEventListener("click", function () {
    var idx = 0,
      min = Infinity;
    cards.forEach(function (c, i) {
      var d = Math.abs(c.offsetLeft - track.scrollLeft);
      if (d < min) {
        min = d;
        idx = i;
      }
    });
    var target = cards[Math.max(0, idx - 1)];
    target.scrollIntoView({
      behavior: "smooth",
      inline: "start",
      block: "nearest",
    });
  });
  nextBtn.addEventListener("click", function () {
    var idx = 0,
      min = Infinity;
    cards.forEach(function (c, i) {
      var d = Math.abs(c.offsetLeft - track.scrollLeft);
      if (d < min) {
        min = d;
        idx = i;
      }
    });
    var target = cards[Math.min(cards.length - 1, idx + 1)];
    target.scrollIntoView({
      behavior: "smooth",
      inline: "start",
      block: "nearest",
    });
  });

  var isDown = false,
    startX = 0,
    startScroll = 0,
    lastX = 0,
    lastT = 0,
    velocity = 0,
    raf = null;
  function momentumLoop() {
    if (Math.abs(velocity) < 0.5) {
      raf = null;
      updateNav();
      return;
    }
    track.scrollLeft -= velocity;
    velocity *= 0.92;
    raf = requestAnimationFrame(momentumLoop);
  }
  track.addEventListener("pointerdown", function (e) {
    isDown = true;
    track.classList.add("oxh-dragging");
    startX = e.clientX;
    startScroll = track.scrollLeft;
    lastX = e.clientX;
    lastT = Date.now();
    velocity = 0;
    if (raf) cancelAnimationFrame(raf);
  });
  track.addEventListener("pointermove", function (e) {
    if (!isDown) return;
    e.preventDefault();
    var dx = e.clientX - startX;
    track.scrollLeft = startScroll - dx;
    var now = Date.now();
    var dt = now - lastT;
    if (dt > 0) velocity = ((e.clientX - lastX) / dt) * 16;
    lastX = e.clientX;
    lastT = now;
  });
  function endDrag() {
    if (!isDown) return;
    isDown = false;
    track.classList.remove("oxh-dragging");
    raf = requestAnimationFrame(momentumLoop);
  }
  track.addEventListener("pointerup", endDrag);
  track.addEventListener("pointerleave", endDrag);
  updateNav();
  window.applyLocale(window.getOxtakLocale());
  var oxeNavCta = (
    window.OXTAK_I18N[window.getOxtakLocale()] || window.OXTAK_I18N.en
  ).elite.nav.cta;
  ["oxh-cta", "oxh-cta-mobile"].forEach(function (id) {
    var el = document.getElementById(id);
    if (el) el.textContent = oxeNavCta;
  });
})();
